import { render, staticRenderFns } from "./InvestmentManagerDetailPage.vue?vue&type=template&id=2f11995c&"
import script from "./InvestmentManagerDetailPage.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports